window.locales = window.locales || {};window.locales.am = window.locales.am || {};window.locales.am.scheduleYourInterviewBox = window.locales.am.scheduleYourInterviewBox || {};window.locales.am.scheduleYourInterviewBox = {...window.locales.am.scheduleYourInterviewBox, ...{
    "headerTitle": "መግቢያ",
    "headerSubtitle": "ይገናኙ ከ",
    "content": "እንኳን ደስ አላችሁ! ለአጭር የመግቢያ ክፍለ ጊዜ ተመርጠዋል። ለዝርዝሮች ኢሜልዎን ይመልከቱ።",
    "ctaText": "ክፍለ ጊዜ ያቅዱ",
    "mobileContent": "ከመግቢያ ጋር ይገናኙ",
    "mobileCtaText": "መርሐግብር"
}
};window.locales.ar = window.locales.ar || {};window.locales.ar.scheduleYourInterviewBox = window.locales.ar.scheduleYourInterviewBox || {};window.locales.ar.scheduleYourInterviewBox = {...window.locales.ar.scheduleYourInterviewBox, ...{
    "headerTitle": "القبول",
    "headerSubtitle": "قابل",
    "content": "تهانينا! لقد تم اختيارك لجلسة قبول قصيرة. راجع بريدك الإلكتروني للمزيد من التفاصيل.",
    "ctaText": "جدولة الجلسة",
    "mobileContent": "قابل القبول",
    "mobileCtaText": "جدول"
}
};window.locales.en = window.locales.en || {};window.locales.en.scheduleYourInterviewBox = window.locales.en.scheduleYourInterviewBox || {};window.locales.en.scheduleYourInterviewBox = {...window.locales.en.scheduleYourInterviewBox, ...{
    "headerTitle": "Admissions",
    "headerSubtitle": "Meet With",
    "content": "Congratulations! You have been selected for a brief admissions session. Check your email for details.",
    "ctaText": "Schedule Session",
    "mobileContent": "Meet with Admissions",
    "mobileCtaText": "Schedule"
}
};window.locales.es = window.locales.es || {};window.locales.es.scheduleYourInterviewBox = window.locales.es.scheduleYourInterviewBox || {};window.locales.es.scheduleYourInterviewBox = {...window.locales.es.scheduleYourInterviewBox, ...{
    "headerTitle": "Admisiones",
    "headerSubtitle": "Reunirse con",
    "content": "¡Felicitaciones! Has sido seleccionado para una breve sesión de admisión. Revisa tu correo electrónico para más detalles.",
    "ctaText": "Programar sesión",
    "mobileContent": "Reunirse con Admisiones",
    "mobileCtaText": "Cronograma"
}
};window.locales.it = window.locales.it || {};window.locales.it.scheduleYourInterviewBox = window.locales.it.scheduleYourInterviewBox || {};window.locales.it.scheduleYourInterviewBox = {...window.locales.it.scheduleYourInterviewBox, ...{
    "headerTitle": "Ammissioni",
    "headerSubtitle": "Incontra",
    "content": "Congratulazioni! Sei stato selezionato per una breve sessione di ammissione. Controlla la tua email per i dettagli.",
    "ctaText": "Pianifica una sessione",
    "mobileContent": "Incontra le Ammissioni",
    "mobileCtaText": "Programma"
}
};window.locales.zh = window.locales.zh || {};window.locales.zh.scheduleYourInterviewBox = window.locales.zh.scheduleYourInterviewBox || {};window.locales.zh.scheduleYourInterviewBox = {...window.locales.zh.scheduleYourInterviewBox, ...{
    "headerTitle": "招生",
    "headerSubtitle": "会见",
    "content": "恭喜！您已被选中参加简短的招生会议。请查看您的电子邮件了解详情。",
    "ctaText": "安排会议",
    "mobileContent": "会见招生部门",
    "mobileCtaText": "日程"
}
};